export default "__VITE_ASSET__CJfZI5Sv__"